import {
  SalesLeadsKanban,
  SalesQuotesKanban,
} from "../../containers/SalesKanban";
import { SalesLeadsTable } from "../../tables/SalesLeadsTable";
import { SalesQuotesTable } from "../../tables/SalesQuotesTable";

export const SALES_TABS = [
  { id: 1, label: "Quotes", icon: "FileText" },
  // { id: 1, label: "Leads", icon: "Users" },
];

const BOARD = 0;
const TABLE = 1;

const VIEWS = {
  [BOARD]: { 0: SalesLeadsKanban, 1: SalesQuotesKanban },
  [TABLE]: { 0: SalesLeadsTable, 1: SalesQuotesTable },
};

export const getView = (tab, viewMode) =>
  VIEWS[viewMode]?.[tab] || VIEWS[BOARD][0];
